module.exports = __webpack_public_path__ + "static/media/ok.cf04ec25.svg";